import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { URL_LOGIN, URL_SECURE_USER_DASHBOARD } from '../../constants/urls';

import Modal from '../Modal/index';
import logo from './imgs/eams_logo.svg';
import LogoutWarning from '../Modal/LogoutWarning/index';
import NavLinks from './NavLinks/index';

import './styles.scss';

const componentBaseClass = 'qoc-navbar';

function NavBar(props = {}) {
  const {
    authenticated,
    isLogoutModalOpen,
    isLoginPathname,
    logout,
    onClickHamburger,
    showHamburgerMenu,
    onLogoutFalse,
    onLogoutCheck
  } = props;
  const onLogoutTrue = () => {
    localStorage.removeItem('pHash');
    localStorage.removeItem('patientHash');
    localStorage.removeItem('activatedUser');
    localStorage.removeItem('emailAddress');
    logout({
      onFulfilled: () => {
        window.location.href = URL_LOGIN;
      }
    });
  };

  const showNavLinks = () => {
    if (
      window.location.href.indexOf('/login/activation') === -1 &&
      !window.location.href.includes('/provider/register')
    ) {
      return true;
    }
    return false;
  };

  return (
    <nav className={`${componentBaseClass} navbar`}>
      <Link to={authenticated ? URL_SECURE_USER_DASHBOARD : URL_LOGIN}>
        <img className="logo" src={logo} alt="logo" />
      </Link>
      {showNavLinks() ? (
        <React.Fragment>
          <NavLinks
            authenticated={authenticated}
            isLoginPathname={isLoginPathname}
            onLogoutCheck={onLogoutCheck}
            onClickHamburger={onClickHamburger}
          />
          <button type="button" className="mobile" onClick={onClickHamburger}>
            {showHamburgerMenu ? (
              <FontAwesomeIcon icon={faTimes} />
            ) : (
              <FontAwesomeIcon icon={faBars} />
            )}
          </button>
          {isLogoutModalOpen && authenticated && (
            <Modal>
              <LogoutWarning
                onLogoutFalse={onLogoutFalse}
                onLogoutTrue={onLogoutTrue}
              />
            </Modal>
          )}
        </React.Fragment>
      ) : null}
    </nav>
  );
}

NavBar.propTypes = {
  authenticated: PropTypes.bool,
  isLogoutModalOpen: PropTypes.bool.isRequired,
  isLoginPathname: PropTypes.bool,
  logout: PropTypes.func.isRequired,
  onClickHamburger: PropTypes.func.isRequired,
  showHamburgerMenu: PropTypes.bool.isRequired,
  onLogoutFalse: PropTypes.func.isRequired,
  onLogoutCheck: PropTypes.func.isRequired
};
NavBar.defaultProps = {
  authenticated: false,
  isLoginPathname: false
};

export default NavBar;
